import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Gazetters from './Gazetters';
import Requests from './Requests';

class Info extends React.PureComponent {
    render() {
        const { current } = this.props;

        return (
            <React.Fragment>
                {
                    current.user
                        ?
                        <React.Fragment>
                            { current.addGazeteer.length > 0 ? <Gazetters gazetters={current.addGazeteer} /> : '' }
                            { current.addRequest.length > 0 ? <Requests requests={current.addRequest} /> : ''}
                        </React.Fragment>
                        :
                        ''
                }
            </React.Fragment>
        );
    }
}

export default connect(
    (state, { from, until, current }) => {
        return {
            from,
            until,
            current,
        };
    },
    dispatch => bindActionCreators({}, dispatch),
)(Info);



// WEBPACK FOOTER //
// ./app/components/Statistics/St/Info/index.js